import React from 'react'
import DatePicker from "react-datepicker";
import DatePickerComponent from './DatePickerComponent';
const InputComponent = ({ grouper, value, handleGrouperData, error, disabled, formatDate }) => {
  const dateFormat = "dd-MM-yyyy";
  const inputField = () => {
    if (grouper.type === "text") {
      return (
        <>
          <input
            className='input_tag'
            type={grouper.type}
            placeholder={grouper.label}
            name={grouper.name}
            autoComplete="off"
            id={grouper.name}
            onChange={(e) => handleGrouperData(e)}
            value={value || ''}
            // disabled={disabled}
          // onBlur={(e) => handleBlur(e)}
          />
        </>
      )
    } 
    else if(grouper.type === "number"){
      return (
        <>
          <input
            className='input_tag'
            type={grouper.type}
            placeholder={grouper.label}
            name={grouper.name}
            min="0"
            id={grouper.name}
            onWheel={(e) => e.target.blur()}
            autoComplete='off'
            onChange={(e) => handleGrouperData(e)}
            value={value || ''}
            // disabled={disabled}
          // onBlur={(e) => handleBlur(e)}
          />
        </>
      )
    }
    else if (grouper.type === "date") {
      return (
        <>
          {/* <DatePickerComponent
            selected={value}
            onChange={handleGrouperData}
            name={grouper.name}
            clearIcon
            calendarIcon
            format={dateFormat}
            enableDates = {grouper.name === "adm_date" || grouper.name === "bir_date" ? value : null }
          /> */}
            <DatePicker
            selected={value || ""}
            onChange={(date) => {
            handleGrouperData({ target: { name: grouper.name, value: date } });
            }}
            showPopperArrow={false}
            showYearDropdown
            format={dateFormat}
            yearDropdownItemNumber={150}
            scrollableYearDropdown
            placeholderText="MM/DD/YYYY"
            // maxDate = {grouper.name === "adm_date" || grouper.name === "bir_date" ? value : null }
    />
        </>
      )
    }
    else if (grouper.type === "select") {
      return (
        <>
          <select
            className='select_tag'
            type={grouper.type}
            name={grouper.name}
            id={grouper.name}
            onChange={(e) => handleGrouperData(e)}
            value={value || ''}
          // onBlur={(e) => handleBlur(e)}
          >
            <option value="" disabled selected>Select an option</option>
            {grouper.options.map(option => (
              <option key={option.value} defaultValue={option.value} value={option.value}>{option.label}</option>
            ))}
          </select>
        </>
      )
    }
  }
  return (
    <>
      <div className='input_row'>
        <div className='input_items'>
          <img src={grouper.icon} alt={grouper.name} className="icon" height="25px" width="25" />
          <label htmlFor={grouper.name} className='input_label'>{String(grouper.label).toUpperCase()}
            <span  className='my-tooltip' data-title={grouper.info}>
              <img src={grouper.info_icon} alt={grouper.info_icon} width="19" height="19" className='info_icon' />
            </span>
          </label>
        </div>
        <div className='input_section'>
          {inputField()}
          {/* {error && <span className="error">{error}</span>} */}
        </div>
      </div>

    </>
  )
}

export default InputComponent